const messages = {
  save: 'Save',
  scheduleExport: 'Schedule for Export',
  scheduleSelected: 'Schedule selected orders for export',
  unscheduleSelected: 'Unschedule selected orders for export',
}

export default messages
